import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { ViewContainerRef, OnInit, Host, ViewChild, HostListener } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { BlockUiService } from '../services/blockui.service';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {

	@ViewChild('modalRef') modalRef: ModalDirective;

	password = '';
	confirmPassword = '';
	message = '';
	error = '';

	constructor(private http: HttpClient, private router: Router, private authService: AuthService, private blockUi: BlockUiService,
		private vcRef: ViewContainerRef) { }

	show() {
		this.clearForm();
		this.modalRef.show();
	}

	submit() {

		this.blockUi.start(this.vcRef);

		this.message = '';
		this.error = '';

		if (this.password !== this.confirmPassword) {
			this.error = 'Паролите не съвпадат.';
			return;
		}

		this.authService.changePassword(this.password).subscribe({
			next: changed => {
				this.message = 'Паролата е сменена успешно.';
				this.blockUi.stop();
				this.modalRef.hide();
				this.authService.logout();
				setTimeout(() => this.router.navigate(['/login']), 100);
			},
			error: errorStatus => {
				console.error('Грешка при смяната на парола:', errorStatus.error.message);
				this.error = 'Грешка при смяната на паролата.' + errorStatus.error.message;
				this.blockUi.stop();
			}
		});

	}

	cancel() {
		this.clearForm();
		this.blockUi.stop();
		this.modalRef.hide();
		this.router.navigate(['/cases']);
	}


	clearForm() {
		this.password = '';
		this.confirmPassword = '';
		this.message = '';
		this.error = '';
	}

}
